import { SearchIcon } from '@chakra-ui/icons';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { PageLayout } from '@/components/templates/PageLayout';
import {
  CmBox,
  CmButton,
  CmFlex,
  CmInput,
  CmInputGroup,
  CmInputRightElement,
  CmLink,
  CmLongLoading,
} from '@/components/uiParts';
import { ManagerAccount } from '@/domain/models/AuthEnterprise';
import { redirect404Page } from '@/lib/AccessControl';
import { routes } from '@/router';
import {
  useManagerAccount,
  useManagerAccountMe,
} from '@/services/AuthEnterprise/hooks';

import { MembersTable } from './components/MembersTable';

const MemberManagementPage: React.FC = () => {
  const history = useHistory();
  const {
    managerAccountMe,
    isLoading: isLoadingMe,
    isError: isErrorMe,
  } = useManagerAccountMe();
  /* アクセス制御 */
  redirect404Page('manage_account', history, managerAccountMe);
  const { managerAccounts, isLoading, isError } = useManagerAccount();
  const [query, setQuery] = useState<string>('');

  const [visibleMembers, setVisibleMembers] = useState<ManagerAccount[]>(
    managerAccounts || []
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      const filtered = managerAccounts?.filter((account) =>
        account.name.includes(query)
      );
      setVisibleMembers(filtered || []);
    }, 500);

    return () => clearTimeout(timer);
  }, [query, managerAccounts]);

  if (isError || isErrorMe) return null;

  return (
    <PageLayout title={routes.SettingsMemberManagement.title}>
      <CmFlex justify="space-between">
        <CmBox w="100%" my={5}>
          <CmFlex justify="flex-end" align="center">
            <CmFlex>
              <CmInputGroup mr={4}>
                <CmInput
                  bg="white"
                  onChange={(e) => setQuery(e.target.value)}
                />
                <CmInputRightElement>
                  <SearchIcon />
                </CmInputRightElement>
              </CmInputGroup>
            </CmFlex>
            {managerAccountMe?.role_type === '管理者' && (
              <CmLink to={routes.SettingsMemberManagementInvite.path}>
                {/*
                 // @ts-ignore TS2590 */}
                <CmButton variant="solid">メンバーを招待する</CmButton>
              </CmLink>
            )}
          </CmFlex>
          <CmBox mt={4} mb={8}>
            <MembersTable memberAccounts={visibleMembers} />
          </CmBox>
        </CmBox>
      </CmFlex>
      {(isLoading || isLoadingMe) && <CmLongLoading />}
    </PageLayout>
  );
};

export default MemberManagementPage;
